import { IDirectOrder } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { DirectOrderWorkItem } from 'src/app/business/direct-order/direct-order-work-item';
import { IWorkItem } from 'src/app/common/contracts/work-item/work-item_T';

import { Command } from '../command';
import { EntityCommandHandler } from '../entity-command-handler';

@Injectable()
export class DirectOrderCommandHandler extends EntityCommandHandler<IDirectOrder> {
  protected workItem: IWorkItem<IDirectOrder>;

  constructor(directOrderWorkItem: DirectOrderWorkItem) {
    super();
    this.workItem = directOrderWorkItem;
  }

  canHandle(command: Command): boolean {
    return command.dtoName === 'DirectOrderDto';
  }
}
